import { render, staticRenderFns } from "./ViewGroupFieldTable.vue?vue&type=template&id=6530d25d&scoped=true"
import script from "./ViewGroupFieldTable.vue?vue&type=script&lang=js"
export * from "./ViewGroupFieldTable.vue?vue&type=script&lang=js"
import style0 from "./ViewGroupFieldTable.vue?vue&type=style&index=0&id=6530d25d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6530d25d",
  null
  
)

export default component.exports